
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/phonics-practice",
      function () {
        return require("private-next-pages/phonics-practice/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/phonics-practice"])
      });
    }
  